import { useTranslation } from "react-i18next";

import { translateIntegrationDisplayName } from "@/features/integrations/utils";
import type { TenantIntegrationModuleForInvoice } from "@/features/invoices/hooks/useTenantIntegrationModulesForInvoices";
import { TableColumn } from "@/types/table/tableProps";

export const useTenantIntegrationModuleForInvoiceTableColumns = () => {
  const { t, i18n } = useTranslation();

  const tenantIntegrationModuleForInvoiceTableColumns: TableColumn<TenantIntegrationModuleForInvoice>[] =
    [
      {
        header: t("common.name"),
        accessor: "name",
        width: "75%",
        Cell: (row: TenantIntegrationModuleForInvoice): JSX.Element => {
          const displayName =
            translateIntegrationDisplayName(row.name, t, i18n) || row.name;
          return (
            <span>
              {displayName} ({row.openInvoiceCount})
            </span>
          );
        },
      },
    ];

  return {
    tenantIntegrationModuleForInvoiceTableColumns,
  };
};
